<template>
  <div class="container" style="margin-top: 30px">
    <div class="card">
      <div class="room" v-if="activeName == 'first' || activeName == 'fourth'">
        <span>房號</span>
        <h2>{{ orderDetail.agency_room_info?orderDetail.agency_room_info.name:''}}</h2>
      </div>
      <div class="userTitle">個人資料</div>
      <div class="userInfo">
        <div>
          <span>客戶姓名</span>
          <el-input v-model="orderDetail.user_name" disabled></el-input>
        </div>
        <div>
          <span>客戶手機</span>
          <el-input v-model="orderDetail.user_phone" disabled></el-input>
        </div>
        <div>
          <span>客戶生日</span>
          <el-date-picker
            v-model="orderDetail.birthday"
            type="date"
            placeholder=""
            format="yyyy/MM/dd"
            value-format="yyyy-MM-dd"
            disabled
          >
          </el-date-picker>
        </div>
        <div v-if="activeName == 'first'" class="shengchan">
          <div>
            <span>生產日期</span>
            <el-date-picker
              v-model="orderDetail.date"
              type="date"
              placeholder=""
              format="yyyy/MM/dd"
              value-format="yyyy-MM-dd"
              disabled
            >
            </el-date-picker>
          </div>
          <div>
            <span>生產方式</span>
            <el-radio-group v-model="orderDetail.way" disabled>
              <el-radio :label="1">自然產</el-radio>
              <el-radio :label="2">剖腹產</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div v-if="activeName == 'second'">
          <span>預產期</span>
          <el-date-picker
            v-model="orderDetail.date"
            type="date"
            placeholder=""
            format="yyyy/MM/dd"
            value-format="yyyy-MM-dd"
            disabled
          />
        </div>
        <div v-if="activeName == 'fourth'">
          <span>出餐房號</span>
          <el-input v-model="orderDetail.agency_room_info.name" disabled></el-input>
        </div>
        <div class="itemflex" v-if="activeName == 'third'">
          <span>客戶地址</span>
          <el-input v-model="orderDetail.newAddress" disabled></el-input>
        </div>
      </div>
    </div>

    <div class="card" v-if="activeName == 'third'">
      <div class="userTitle">配送資訊</div>
      <div class="userInfo">
        <div class="itemflex" v-for="(item,i) in orderDetail.newOrderAddress">
          <span>配送地址{{ i + 1 }}</span>
          <el-input v-model="item.address" disabled></el-input>
        </div>
        <div>
          <div style="margin-right: 50px">
            <span>備用聯絡人1</span>
            <el-input v-model="orderDetail.liaison[0].name" disabled></el-input>
          </div>
          <div>
            <span>電話</span>
            <el-input v-model="orderDetail.liaison[0].phone" disabled></el-input>
          </div>
          <div>
            <span>，是否顯示 ：</span>
            <el-radio-group v-model="orderDetail.liaison[0].isshow" disabled>
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div>
          <div style="margin-right: 50px">
            <span>備用聯絡人2</span>
            <el-input v-model="orderDetail.liaison[1].name" disabled></el-input>
          </div>
          <div>
            <span>電話</span>
            <el-input v-model="orderDetail.liaison[1].phone" disabled></el-input>
          </div>
          <div>
            <span>，是否顯示 ：</span>
            <el-radio-group v-model="orderDetail.liaison[0].isshow" disabled>
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-if="activeName == 'third'">
      <div class="userTitle">訂購人資訊</div>
      <div class="userInfo">
        <div>
          <div style="margin-right: 50px">
            <span>訂購人</span>
            <el-input v-model="orderDetail.user_name" disabled></el-input>
          </div>
          <div>
            <span>手機</span>
            <el-input v-model="orderDetail.user_phone" disabled></el-input>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="userTitle">用餐資訊</div>
      <div class="userInfo">
        <div style="margin-bottom: 10px">
          <span>{{ activeName == "third" ? "訂單項目" : "餐點類別" }} </span>
          <el-radio-group v-model="orderDetail.item" disabled>
            <el-radio :label="1">月子膳食</el-radio>
            <el-radio :label="2">養胎膳食</el-radio>
            <el-radio :label="3">小產膳食</el-radio>
            <el-radio :label="4">術後膳食</el-radio>
            <el-radio :label="5">調養膳食</el-radio>
          </el-radio-group>
        </div>
        <div style="align-items: stretch" v-if="activeName != 'second'">
          <span style="margin-top: 10px"> {{ activeName == "third" ? "訂購時間" : "用餐期間" }} </span>
          <div style="display: block">
            <div>
              <div style="margin-right: 50px">
                <span>起餐</span>
                <el-date-picker
                  v-model="orderDetail.start_date"
                  type="date"
                  placeholder=""
                  format="yyyy/MM/dd"
                  value-format="yyyy-MM-dd"
                  disabled
                >
                </el-date-picker>
              </div>
              <div>
                <span>餐期</span>
                <el-select v-model="orderDetail.start_stage" placeholder="" disabled>
                  <el-option label="早餐" :value="1"></el-option>
                  <el-option label="午餐" :value="2"></el-option>
                  <el-option label="晚餐" :value="3"></el-option>
                </el-select>
              </div>
            </div>
            <div>
              <div style="margin-right: 50px">
                <span>完餐</span>
                <el-date-picker
                  v-model="orderDetail.end_date"
                  type="date"
                  placeholder=""
                  format="yyyy/MM/dd"
                  value-format="yyyy-MM-dd"
                  disabled
                >
                </el-date-picker>
              </div>
              <div>
                <span>餐期</span>
                <el-select v-model="orderDetail.end_stage" placeholder="" disabled>
                  <el-option label="早餐" :value="1"></el-option>
                  <el-option label="午餐" :value="2"></el-option>
                  <el-option label="晚餐" :value="3"></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
        <div v-if="activeName == 'second'">
          <span>試吃時間</span>
          <div style="display: block">
            <div style="margin-bottom: 0">
              <div style="margin-right: 50px">
                <span>日期</span>
                <el-date-picker
                  v-model="orderDetail.start_date"
                  type="date"
                  placeholder=""
                  format="yyyy/MM/dd"
                  value-format="yyyy-MM-dd"
                  disabled
                >
                </el-date-picker>
              </div>
              <div>
                <span>餐期</span>
                <el-select v-model="orderDetail.start_stage" placeholder="" disabled>
                  <el-option label="早餐" :value="1"></el-option>
                  <el-option label="午餐" :value="2"></el-option>
                  <el-option label="晚餐" :value="3"></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
        <div v-if="activeName == 'third'">
          <span>訂購天數</span>
          <span>早餐</span>
          <el-input v-model="orderDetail.breakfast_num" style="width: 100px" disabled></el-input>
          <span>天 /</span>
          <span>午餐</span>
          <el-input v-model="orderDetail.lunch_num" style="width: 100px" disabled></el-input>
          <span>天 /</span>
          <span>晚餐</span>
          <el-input v-model="orderDetail.dinner_num" style="width: 100px" disabled></el-input>
          <span>天</span>
        </div>
        <!--        <div v-if='activeName == "third"'>-->
        <!--           <span>訂購優惠</span>-->
        <!--          <el-input disabled></el-input>-->
        <!--        </div>-->
        <div v-if="activeName == 'third'">
          <span>訂單總額</span>
          <el-input v-model="orderDetail.amount" disabled></el-input>
          <span>元</span>
        </div>
      </div>
      <div class="userTitle">選菜權限</div>
      <div class="kaitong">
        <span :class="orderDetail.user_info.choose == 1?'active':''">已開通</span>
        <span :class="orderDetail.user_info.choose == 0?'active':''">未開通</span>
      </div>
    </div>

    <div class="card" v-if="activeName == 'third'">
      <div class="userTitle">其他訂單資訊</div>
      <div class="userInfo">
        <div class="shengchan">
          <div>
            <span>生產日期</span>
            <el-date-picker
              v-model="orderDetail.date"
              type="date"
              placeholder=""
              format="yyyy/MM/dd"
              value-format="yyyy-MM-dd"
              disabled
            >
            </el-date-picker>
          </div>
          <div>
            <span>生產方式</span>
            <el-radio-group v-model="orderDetail.way" disabled>
              <el-radio :label="1">自然產</el-radio>
              <el-radio :label="2">剖腹產</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="userTitle">飲食禁忌</div>
      <jinji :disadled="true" v-model="orderDetail.taboo['1']" :tag="orderDetail.taboo['1']"></jinji>
      <div class="userTitle"> {{ activeName == "third" ? "其他備註" : "備註" }}</div>
      <el-input
        v-model="orderDetail.card_remark[0].content"
        type="textarea"
        :rows="5"
        disabled>
      </el-input>
    </div>

    <div class="card" v-if="activeName != 'second'">
      <div class="userTitle">出餐詳情</div>
      <div class="_num">
        <p>用餐數量</p>
          <p>早餐 <span>{{ orderDetail.breakfast_num }}</span></p>
            <p>午餐 <span>{{ orderDetail.lunch_num }}</span></p>
            <p>晚餐 <span>{{ orderDetail.dinner_num }}</span></p>
      </div>
      <rili v-model="orderDetail.day_detail" :starttime="orderDetail.start_date" />
    </div>
    <div class="btn">
      <el-button @click="fanhui">返回上一頁</el-button>
    </div>
  </div>
</template>

<script>
import { getAddress } from "@/api";
import { getAllDate } from "@/utils";

export default {
  name: "orderDetail.vue",
  components: {
    jinji: () => import("@/components/jinji.vue"),
    rili: () => import("@/components/rili.vue")
  },
  props: {
    activeName: {
      type: String,
      default: "first"
    },
    orderDetail: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      addressList: []
    };
  },
  mounted() {
    this.getAddressList();
    if (
      this.orderDetail.start_date &&
      this.orderDetail.start_stage &&
      this.orderDetail.end_date &&
      this.orderDetail.end_stage
    ) {
      this.$set(this.orderDetail, "day_detail", getAllDate(
        this.orderDetail.start_date,
        this.orderDetail.end_date,
        this.orderDetail.start_stage,
        this.orderDetail.end_stage
      ));
    }
  }
  ,
  methods: {
    fanhui() {
      this.$emit("done");
    }
    ,
    getAddressList()
{
  getAddress().then(res => {
    this.addressList = res.data.list;
    let arr = [];
    let address = (this.orderDetail.city ? this.addressList.find(item => item.id == this.orderDetail.city).name : "") +
      (this.orderDetail.city && this.orderDetail.area ? this.addressList.find(item => item.id == this.orderDetail.city).child.find(it => it.id == this.orderDetail.area).name : "") + this.orderDetail.address;
    this.orderDetail.order_address.map(items => {
      let addressString = (items.city ? this.addressList.find(item => item.id == items.city).name : "") +
        (items.city && items.area ? this.addressList.find(item => item.id == items.city).child.find(it => it.id == items.area).name : "") + items.address;
      arr.push({ address: addressString });
      return items;
    });
    this.$set(this.orderDetail, "newAddress", address);
    this.$set(this.orderDetail, "newOrderAddress", arr);
  });
}

}
}
;
</script>


<style scoped lang="scss">
.card {
  padding: 20px 30px;
  background: #FFFFFF;
  border-radius: 15px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.room {
  display: flex;
  align-items: center;
  letter-spacing: 2px;
  padding-left: 20px;

  span {
    color: #b6b8bd;
    margin-right: 20px;
    font-size: 18px;
  }

  h2 {
    margin: 0;
  }
}

.userTitle {
  color: #DBBD80;
  font-size: 18px;
  letter-spacing: 2px;
  padding-left: 15px;
  border-left: 3px solid #DBBD80;
  margin: 20px 0;
}

.userInfo {
  padding-left: 20px;

  div {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 5px;

    span {
      font-size: 18px;
      margin-right: 20px;
      color: #b6b8bd;
      white-space: nowrap;
    }

    .el-input {
      width: 220px;
    }

    ::v-deep .el-input.is-disabled .el-input__inner {
      border: none;
      background: transparent;
      border-bottom: 1px solid #DCDFE6;
      border-radius: 0;
    }

  }
}

.shengchan {
  display: flex;
  flex-wrap: wrap;

  div:first-child {
    margin-right: 50px;
  }

}

::v-deep .el-radio__inner {
  width: 18px;
  height: 18px;
  border-radius: 2px;
}

::v-deep .el-radio__label {
  font-size: 18px;
}

::v-deep .el-radio {
  display: flex;

}

::v-deep .el-radio__input.is-disabled.is-checked .el-radio__inner {
  background: #000000;
  border-color: #000000;
}

::v-deep .el-radio__input.is-disabled.is-checked .el-radio__inner::after {
  display: none;
}

.kaitong {
  display: inline-block;
  border: 1px solid #DBBD80;
  border-radius: 7px;
  color: #b6b8bd;

  span {
    display: inline-block;
    padding: 5px 20px;
  }

  .active {
    background: #DBBD80;
    color: #FFFFFF;
    border-radius: 0 5px 5px 0;
  }
}

::v-deep .el-textarea.is-disabled .el-textarea__inner {
  background: transparent;
}

.btn {
  text-align: center;
  margin-bottom: 20px;

  .el-button {
    background: #DBBD80;
    color: #FFFFFF;
  }
}

.itemflex {
  display: flex;

  .el-input {
    flex-grow: 1;
  }
}

._num {
  display: flex;
  align-items: center;
  justify-content: start;
  margin-bottom: 20px;

  p {
    margin: 0;
    font-size: 18px;
    color: #b6b8bd;
    white-space: nowrap;
    border-right: 1px solid #b6b8bd;
    padding: 0 20px;

    span {
      margin-left: 5px;
      color: #DBBD80;
    }
  }

  p:first-child, p:last-child {
    border-right: none;
    padding-right: 0;
  }
  p:first-child{
    padding: 0;
  }
}
</style>
